import DragAndDropFiles from "@mirage/components/dragAndDrop/DragAndDropFiles";
import { Chip } from "@mui/material";
import Box from "@mui/material/Box";
import { UploadedFile } from "@shared/mirage/core/contracts/UploadedFile";
import React, { useCallback } from "react";
import { atom, useRecoilState } from "recoil";

export const commentFiles = atom({
    key: "comment-attachments",
    default: [] as UploadedFile[],
});

const NewCommentAttachments = () => {
    const [files, setFiles] = useRecoilState<UploadedFile[]>(commentFiles);

    const removeAttachment = (index: number) => {
        setFiles((prev) => {
            const copy = [...prev];
            copy.splice(index, 1);
            return [...copy];
        });
    };

    const handleFileDrop = useCallback(
        (files: UploadedFile[]) => {
            if (files?.length) {
                setFiles((prev) => {
                    return [...prev, ...files];
                });
            }
        },
        [setFiles]
    );

    const handleFileClick = useCallback(
        (files: UploadedFile[]) => {
            if (files?.length) {
                setFiles((prev) => {
                    return [...prev, ...files];
                });
            }
        },
        [setFiles]
    );

    return (
        <>
            <Box className="newCommentForm__attachmentsContainer">
                <DragAndDropFiles onDrop={handleFileDrop} onClick={handleFileClick} />
                <Box className="newCommentForm__attachmentsContainer__chipsContainer">
                    {files?.map((attachment, index) => {
                        return (
                            <Chip
                                label={attachment.name}
                                onDelete={() => removeAttachment(index)}
                                key={`${attachment.name}-${index}`}
                                className="newCommentForm__attachmentsContainer__chipsContainer__chip"
                            />
                        );
                    })}
                </Box>
            </Box>
        </>
    );
};

export default NewCommentAttachments;
